import React from "react";
import ReactDOM from "react-dom/client";
import "../src/Themes/main.css";
import "../src/Themes/color.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
